// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StarFilledSvg from "@fishx/icons-svg/es/asn/StarFilled";
import FishxIcon from '../components/FishxIcon';

var StarFilled = function StarFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StarFilledSvg
  }));
};

StarFilled.displayName = 'StarFilled';
export default React.forwardRef(StarFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StarFilled.js
// module id = 4186
// module chunks = 0